import React from "react";
import apiProxy from "../../api/apiProxy";
import OverridesGroupedListPage from "./OverridesGroupedListPage";

export default props => (
  <OverridesGroupedListPage
    getOverride={apiProxy.storeLighting.getOverride}
    overrideId={props.match.params.overrideId}
  />
);
